import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useRouteDataStore = defineStore('route-data', {
  state: () => {
    return {
      routeData: null,
    };
  },

  actions: {
    setRouteData(routeData) {
      this.routeData = routeData;
    }
  },
});